import React from 'react';
import { toastr } from 'react-redux-toastr';
import Modal from '../../commons/modal/modal';
import styles from './ceTaskboard.scss';
import TextArea from '../../commons/formElements/textArea/textArea';

const RejectHolidayDeliveryRequestModal = props => {
  const {
    showModal,
    closeModal,
    rowData,
    reason,
    setReason,
    rejectHolidayDeliveryRequest
  } = props;

  const handleSubmit = () => {
    const editedReason = reason.trim();

    if (!editedReason.length) {
      toastr.light('Warning', 'Please enter valid reason for rejection!');
      return;
    }

    const obj = {
      cnote: rowData && rowData.cnote,
      reasonForRejection: editedReason
    };

    rejectHolidayDeliveryRequest(obj);
  };

  return (
    <Modal
      showModal={showModal}
      title="Reject Holiday Delivery Request"
      closeModal={closeModal}
    >
      <div className={`l-col ${styles.modalContentWrapper}`}>
        <div
          className={`flex-100 l-row ${styles.modalText} ${styles.holidayDeliveryRequestModalText}`}
        >
          CN: {(rowData && rowData.cnote) || ''}
        </div>
        <div>
          <TextArea
            placeholder="Enter Reason (Maximum 100 Characters)"
            inputClassName={styles.holidayDeliveryRequestModalTextArea}
            rows={6}
            maxLength="100"
            value={reason}
            onChange={value => setReason(value)}
          />
        </div>
        <div className="l-row j-end a-end">
          <div
            className={`${styles.cancelBtnWrapper} l-row j-center a-center`}
            onClick={closeModal}
          >
            CANCEL
          </div>
          <div
            className={`${styles.submitBtnWrapper} l-row j-center a-center`}
            onClick={handleSubmit}
          >
            SUBMIT
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RejectHolidayDeliveryRequestModal;
